import BaseModel from "./BaseModel"

export default class LicenseModel extends BaseModel {
    get schema() {
        return {
            number: "",
            issued_at: "",
            activity_type: "",
            issued_by: "",
            activity_list: "",
            end_at: "",
            document_id: ""
        }
    }

    prepareCreate() {
        this.baseClear()

        return this
    }

    prepareUpdate() {
        this.baseClear()

        return this
    }
}
